import { render, staticRenderFns } from "./ConnectionMenu.vue?vue&type=template&id=1670d801&scoped=true"
import script from "./ConnectionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectionMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConnectionMenu.vue?vue&type=style&index=0&id=1670d801&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670d801",
  null
  
)

export default component.exports